/* ============================================================
   BBF Cart Drawer — open/close, qty update, remove, refresh
   ============================================================ */
(function () {

  var drawer  = document.getElementById('bbf-cart-drawer');
  var overlay = document.getElementById('bbf-cart-overlay');
  var closeBtn = document.getElementById('bbf-cart-close');
  var cartIcon = document.getElementById('cart-icon-bubble');

  if (!drawer) return;

  /* ---- Milestone confetti ----
     Fires from the checkout button every time the cart crosses a new reward
     milestone (free shipping, ₹100 off, 5% off). The drawer renders
     data-reached="0-3" on .bbf-ms; we compare it before/after each refresh. */
  var initMs = drawer.querySelector('.bbf-ms');
  var lastReached = initMs ? (parseInt(initMs.getAttribute('data-reached'), 10) || 0) : 0;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CONFETTI_COLORS = ['#6b1414', '#c6a24a', '#e6b23c', '#f5f0e8', '#2a7a2a', '#d9534f', '#ffffff'];

  function confettiBurst(originX, originY) {
    var canvas = document.createElement('canvas');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    canvas.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483000;';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    var parts = [];
    for (var i = 0; i < 110; i++) {
      var angle = (-Math.PI / 2) + (Math.random() - 0.5) * Math.PI * 1.1; /* fan upward */
      var speed = 7 + Math.random() * 9;
      parts.push({
        x: originX, y: originY,
        vx: Math.cos(angle) * speed, vy: Math.sin(angle) * speed,
        size: 5 + Math.random() * 6,
        color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
        rot: Math.random() * Math.PI * 2, vr: (Math.random() - 0.5) * 0.4,
        round: Math.random() < 0.3
      });
    }
    var start = null, DURATION = 2400;
    function frame(ts) {
      if (start === null) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var fade = elapsed > DURATION - 600 ? Math.max(0, (DURATION - elapsed) / 600) : 1;
      parts.forEach(function (p) {
        p.vy += 0.28; p.vx *= 0.992; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        ctx.save();
        ctx.globalAlpha = fade;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.round) { ctx.beginPath(); ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2); ctx.fill(); }
        else { ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2); }
        ctx.restore();
      });
      if (elapsed < DURATION) { requestAnimationFrame(frame); }
      else if (canvas.parentNode) { canvas.parentNode.removeChild(canvas); }
    }
    requestAnimationFrame(frame);
    /* safety: never leave the overlay behind */
    setTimeout(function () { if (canvas.parentNode) canvas.parentNode.removeChild(canvas); }, DURATION + 1500);
  }

  function celebrateMilestones(count) {
    if (reduceMotion) return;
    for (var i = 0; i < count; i++) {
      setTimeout(function () {
        var btn = drawer.querySelector('.bbf-cart-drawer__checkout');
        var r = btn ? btn.getBoundingClientRect() : null;
        var x = r ? r.left + r.width / 2 : window.innerWidth / 2;
        var y = r ? r.top + r.height / 2 : window.innerHeight - 80;
        confettiBurst(x, y);
      }, 500 + i * 600); /* wait for the drawer to finish sliding in */
    }
  }

  /* ---- Open / Close ---- */
  function openCart() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.documentElement.classList.add('bbf-cart-open');
    document.body.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeCart() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('bbf-cart-open');
    document.body.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
  }

  /* Cart icon: open the drawer instead of navigating to /cart */
  if (cartIcon) {
    cartIcon.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCart();
      openCart();
    });
  }

  if (closeBtn)  closeBtn.addEventListener('click', closeCart);
  if (overlay)   overlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* ---- Refresh cart via section rendering API ---- */
  function refreshCart() {
    var body = document.getElementById('bbf-cart-body');
    if (body) body.classList.add('is-loading');

    fetch('/?sections=bbf-cart-drawer', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (!data['bbf-cart-drawer']) return;

      /* Parse the returned HTML and replace relevant nodes */
      var parser = new DOMParser();
      var doc = parser.parseFromString(data['bbf-cart-drawer'], 'text/html');

      /* Replace drawer inner content */
      var newDrawer = doc.getElementById('bbf-cart-drawer');
      if (newDrawer && drawer) {
        drawer.innerHTML = newDrawer.innerHTML;
        /* Re-bind inner close button */
        var newClose = drawer.querySelector('#bbf-cart-close');
        if (newClose) newClose.addEventListener('click', closeCart);
      }

      /* Reward milestones: celebrate every newly reached one */
      var msNow = drawer.querySelector('.bbf-ms');
      var reachedNow = msNow ? (parseInt(msNow.getAttribute('data-reached'), 10) || 0) : 0;
      if (reachedNow > lastReached) { celebrateMilestones(reachedNow - lastReached); }
      lastReached = reachedNow;

      /* Update cart count bubbles */
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.bbf-cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          });
        });
    })
    .catch(function (err) {
      console.warn('BBF cart refresh error:', err);
      if (body) body.classList.remove('is-loading');
    });
  }

  /* ---- Change quantity ---- */
  function changeQty(line, qty) {
    if (qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function () { refreshCart(); })
    .catch(function (err) { console.warn('BBF qty change error:', err); });
  }

  /* ---- Event delegation inside drawer ---- */
  drawer.addEventListener('click', function (e) {

    /* Qty buttons */
    var qtyBtn = e.target.closest('.bbf-cart-item__qty-btn');
    if (qtyBtn) {
      var line = parseInt(qtyBtn.dataset.line, 10);
      var qty  = parseInt(qtyBtn.dataset.qty, 10);
      changeQty(line, qty);
      return;
    }

    /* Upsell: add the suggested product, then re-render the drawer */
    var upsellBtn = e.target.closest('.bbf-cart-upsell__add');
    if (upsellBtn) {
      if (upsellBtn.disabled) return;
      upsellBtn.disabled = true;
      upsellBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(upsellBtn.dataset.variantId, 10), quantity: 1 }] })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () { refreshCart(); })
      .catch(function (err) {
        console.warn('BBF upsell add error:', err);
        upsellBtn.disabled = false;
        upsellBtn.textContent = 'Add to cart';
      });
      return;
    }

    /* Remove button */
    var removeBtn = e.target.closest('.bbf-cart-item__remove');
    if (removeBtn) {
      var line = parseInt(removeBtn.dataset.line, 10);
      changeQty(line, 0);
      return;
    }
  });

  /* ---- Listen for ATC success from product section ---- */
  document.addEventListener('bbf:cart:updated', function () {
    refreshCart();
    openCart();
  });

})();
